import { Add, AddCircleOutlineRounded } from "@mui/icons-material";
import { Button } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";
import { type HyperTableAddRowButtonProps } from "../types";

const HyperTableAddRowButton: React.FC<HyperTableAddRowButtonProps> = (
  props,
) => {
  const {} = props;

  return (
    <Button
      sx={
        !isMobile
          ? {
              gap: "0.5rem",
              borderRadius: "1rem",
              alignItems: "center",
              padding: "0.4rem 1.5rem",
            }
          : {
              position: "absolute",
              right: "2.5rem",
              bottom: "6.5rem",
              zIndex: 5,
              width: "2.8rem",
              height: "2.8rem",
              minWidth: 0,
              borderRadius: "40%",
            }
      }
      variant="contained"
      color="primary"
      onClick={props.onClick}
    >
      {props.icon ? (
        props.icon
      ) : !isMobile ? (
        <AddCircleOutlineRounded
          sx={{ fontSize: "1.25rem" }}
          aria-hidden="true"
        />
      ) : (
        <Add />
      )}
      {!isMobile && props.content}
    </Button>
  );
};

export default HyperTableAddRowButton;
